import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { WaveDivider } from './ui/WaveDivider';
export function ProblemSection() {
  const failedApproaches = [{
    title: 'Intense cardio',
    desc: 'spikes your cortisol even higher and wears down your joints, leaving you more inflamed than when you started.'
  }, {
    title: 'Low-calorie diets',
    desc: 'stress your adrenal glands, causing your body to cling to every ounce of fat for fear of starvation.'
  }, {
    title: 'Melatonin supplements',
    desc: "only silence the symptom; they don't turn off the internal alarm signal that stores fat in your gut."
  }, {
    title: 'Counting calories',
    desc: 'completely ignores the hormonal "on/off" switch that actually controls your weight after menopause.'
  }];
  return <section className="relative bg-white pt-8 pb-4" data-id="element-177">
      <WaveDivider position="top" fill="#FDF8F0" className="absolute top-0 left-0 w-full -mt-[1px]" data-id="element-178" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16" data-id="element-180">
          <h2 className="text-sm font-bold tracking-widest text-gold uppercase mb-3" data-id="element-181">
            The Problem
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-182">
            The "Cortisol Storm" Locking Your Metabolism
          </h3>

          <div className="pl-6 border-l-4 border-deep-teal space-y-4 text-lg text-gray-700" data-id="element-183">
            <p data-id="element-184">
              After 40, your hormones no longer follow the rules of calories.
              Daily life stress, shifts in estrogen, and a lack of deep REM
              sleep create a "Cortisol Storm" that locks your metabolism.
            </p>
            <p data-id="element-185">
              If you wake up between 2 AM and 4 AM with a racing mind, cold
              sweats, or sudden anxiety, your body is flooded with survival
              hormones. In this state, it is biologically impossible to burn
              fat. You are trapped in a "Wired but Tired" cycle that is
              destroying your health and your confidence.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-186">
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-187">
            Why What You Tried Didn't Work
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-188">
            {failedApproaches.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-cream/50 p-6 rounded-2xl border border-cream flex items-start gap-4" data-id="element-189">
                <div className="bg-emergency-red/10 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-190">
                  <XIcon className="w-5 h-5 text-emergency-red" data-id="element-191" />
                </div>
                <p className="text-gray-700 leading-relaxed" data-id="element-192">
                  <strong className="text-deep-teal block mb-1" data-id="element-193">
                    {item.title}
                  </strong>
                  {item.desc}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}